import React from 'react';
import ReactDOM from 'react-dom';
import BeatLoader from "react-spinners/BeatLoader";

import './index.css';
import App from './App';
//import App_MSIS from './App_msis';
import { AssetsApiClient, AssetsPluginContext } from '@woodwing/assets-client-sdk';
//import Amplify, { API, Auth } from 'aws-amplify'

let key = window.location.search.replace("?licence=", "")




window.dropdownDB = {}
AssetsPluginContext.get()
  .then(contextService => {
    //   console.log({ GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG: contextService._context })
    // try {
    //   window.apiKey = contextService._context.plugin.action.configProperties.find(x => x.name == "api-key").value
    // } catch (error) {
    //   try {
    //     window.apiKey = contextService._context.plugin.panel.configProperties.find(x => x.name == "api-key").value
    //   } catch (error) {

    //   }

    // }
    // if (window.apiKey === undefined) {
    //   ReactDOM.render(<h1>NO API KEY FOUND IN CONFIG PROPERTIES</h1>, document.getElementById('root'))
    //   return

    // }



    getConfig(key)
      .then(config => {
        //GrabSourcesFromDropdownInConfig(config)
        //  console.log({ config })
        ReactDOM.render(
          <BeatLoader color={"#0095e0"} css={{ top: "40%", left: "45%", position: "absolute", }} size={10} />
          , document.getElementById('root')
        )

        window.apiClient = AssetsApiClient.fromPluginContext(contextService)
        let assetid
        try {
          assetid = contextService._context.activeTab.originalAssetSelection[0].id
        } catch (error) {

        }

        window.DAMURL = contextService._connectedClientUrl

        //console.log({ DAMURL: window.DAMURL })

        const searchResults = window.apiClient.search({ q: `id: ${assetid}`, appendRequestSecret: true })
          .then(res => {
            if (res.hits.length > 0) {
              try {
                window.previewWithSecret = res.hits[0].previewUrl
                window.OriginalWithSecret = res.hits[0].originalUrl
                const regex = /(?<=requestSecret=)(.*)(?=)/g;
                window.requestSecret = window.previewWithSecret.match(regex).toString()
                console.log({ preview: window.previewWithSecret, requestSecret: window.requestSecret, res })
              } catch (error) {

              }

            }



            // console.log({ contextService })
            // console.log({ type: contextService._context.plugin.type, contextService })
            window.pluginType = contextService._context.plugin.type
            window.elvisContext = contextService._context
            window.config = config
            window.assetsPluginContext = contextService
            console.log({ config })
            if (config.brief_mapping) {
              //   ReactDOM.render(<App_MSIS config={config} selectedAsset={contextService._context.activeTab.originalAssetSelection[0]} />, document.getElementById('root'))
            } else {
              ReactDOM.render(<App config={config} />, document.getElementById('root'))
            }
          })
      })


  })

//console.log({ props: AssetsPluginContext })






async function getConfig(key) {
  try {
    return new Promise((resolve, reject) => {


      var requestOptions = {
        method: 'POST',
        redirect: 'follow'
      };

      //requestOptions.headers['Cache-Control'] = 'must-revalidate'
      //requestOptions.headers['Pragma'] = 'no-cache'
      //requestOptions.headers['Expires'] = '0'


      fetch(`https://license.evolvedmedia.co.uk:1337/licence/${key}`, requestOptions)
        .then(response => response.text())
        .then(result => resolve(JSON.parse(result.toString()).config))
        .catch(error => console.log('error', error));


      // var https = require('follow-redirects').https;
      // var options = {
      //   'method': 'POST',
      //   'hostname': 'license.evolvedmedia.co.uk',
      //   'port': 1337,
      //   'path': '/licence/1c20e151-d4e8-4230-b31e-24acbdfd251f',
      //   'headers': {
      //   },
      //   'maxRedirects': 20
      // };

      // var req = https.request(options, function (res) {
      //   var chunks = [];

      //   res.on("data", function (chunk) {
      //     chunks.push(chunk);
      //   });

      //   res.on("end", function (chunk) {
      //     var body = Buffer.concat(chunks);
      //     console.log({ body: body.toString() })

      //     resolve(JSON.parse(body.toString()).config)
      //     console.log(body.toString());
      //   });

      //   res.on("error", function (error) {
      //     console.error(error);
      //   });
      // });

      // req.end();
    })


    // const config = await API.post("authAPI", "/config", {
    //   'content-type': "text/plain",
    //   "access-control-allow-origin": "*",
    //   "body": key,
    //   "headers": {
    //     "x-api-key": window.apiKey
    //   }
    // });
    //return config
  } catch (err) { console.log(`error fetching config ${err}`) }
}


async function GrabSourcesFromDropdownInConfig(config) {

  let data = await fetchDataFromDatabase()
  // Initialize an empty array to store the dropdown sources
  const dropdownSources = [];

  // Iterate over the config tabs
  for (const tab of config.tabs) {
    // Iterate over the sections in each tab
    for (const section of tab.sections) {
      // Check if the section has rows
      if (section.rows) {
        // Iterate over the rows in the section
        for (const row of section.rows) {
          // Check if the row is a dropdown and has a source
          if (
            row.sectionType === 'dropdown' &&
            row.source &&
            typeof row.source === 'string'
          ) {
            // Push the source into the array
            dropdownSources.push(row.source);
            try {
              row.values = JSON.parse(unescape(data[row.dbName].find(x => x.name === row.listName).list)).map(x => x.text)
            } catch (error) {

            }

          }
        }
      }
    }
  }

  // Output the dropdown sources array
  //console.log({ dropdownSources });
}



const fetchDataFromDatabase = async () => {
  let data = await mySQLConnector()

  // Return a promise that fetches the values from the database

  return data

  // resolve(fetchedValues);


};


async function mySQLConnector(body) {
  //console.log({ checker: data })
  try {
    // const config = await API.post("authAPI", "/mysqlConnector", {
    //   'content-type': "text/plain",
    //   "access-control-allow-origin": "*",
    //   "body": body,
    //   "headers": {
    //     "x-api-key": window.apiKey
    //   }
    // });

    // return config
  } catch (err) { console.log(`error fetching config ${err}`) }
}


